// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENTER_TO_GROUP = "Vstup do skupiny";
export const GROUP_ASKED_TO_JOIN = "Po\u017e\u00e1dala jsi o \u010dlenstv\u00ed";
export const GROUP_ASK_TO_JOIN = "Po\u017e\u00e1dej o \u010dlenstv\u00ed";
export const GROUP_counter_ACTIVE_MEMBERS = ["%(counter)s aktivn\u00ed \u010dlen", "%(counter)s aktivn\u00ed \u010dlenov\u00e9", "%(counter)s aktivn\u00edch \u010dlen\u016f"];
export const JOIN_GROUP = "P\u0159idej se ke skupin\u011b";
export const NEW_FEMININE = "Nov\u00e1";
